(function () {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const scopeSelector = [
    '#looxReviews',
    '[id*="loox_reviews"]',
    '[id*="looxReviews"]',
    '[class*="loox"]',
    '[data-loox]',
  ].join(',');
  const cardSelector = [
    '.loox-review',
    '.loox-review-card',
    '.review',
    '.grid-item',
    '[data-review-id]',
    '[class*="review-card"]',
    '[class*="review-item"]',
  ].join(',');
  const textSelector = [
    '.loox-review-content',
    '.loox-review-body',
    '.loox-review-text',
    '.review-content',
    '[class*="review-content"]',
    '[class*="review-body"]',
    '[class*="review-text"]',
  ].join(',');

  function uniqueElements(elements) {
    return Array.from(new Set(elements.filter(Boolean)));
  }

  function configureLooxMobileLimit() {
    const widgets = uniqueElements(Array.from(document.querySelectorAll('#looxReviews, [id*="looxReviews"]')));

    widgets.forEach((widget) => {
      widget.setAttribute('data-limit-mobile', '4');
    });

    if (!mobileQuery.matches) return;

    document.querySelectorAll('iframe#looxReviewsFrame').forEach((frame) => {
      try {
        const url = new URL(frame.getAttribute('src') || '', window.location.href);
        if (!url.hostname.includes('loox.io') || !url.pathname.includes('/reviews')) return;
        if (url.searchParams.get('limit') === '4') return;

        url.searchParams.set('limit', '4');
        frame.setAttribute('src', url.toString());
      } catch (error) {
        // Ignore malformed third-party iframe URLs.
      }
    });
  }

  function resetLooxMobileReviews() {
    document.querySelectorAll('.piur-loox-mobile-track').forEach((element) => {
      element.classList.remove('piur-loox-mobile-track');
    });
    document.querySelectorAll('.piur-loox-mobile-card').forEach((element) => {
      element.classList.remove('piur-loox-mobile-card');
      element.removeAttribute('data-piur-loox-extra');
    });
    document.querySelectorAll('.piur-loox-mobile-text').forEach((element) => {
      element.classList.remove('piur-loox-mobile-text');
    });
  }

  function groupCardsByParent(cards) {
    return cards.reduce((groups, card) => {
      if (!card.parentElement) return groups;
      const group = groups.get(card.parentElement) || [];
      group.push(card);
      groups.set(card.parentElement, group);
      return groups;
    }, new Map());
  }

  function findReviewText(card) {
    const explicitText = uniqueElements(Array.from(card.querySelectorAll(textSelector)))
      .find((element) => (element.textContent || '').trim().length > 80);

    if (explicitText) return explicitText;

    return Array.from(card.querySelectorAll('p, div'))
      .find((element) => {
        const text = (element.textContent || '').trim();
        return text.length > 120 && element.children.length <= 2;
      });
  }

  function applyLooxMobileReviews() {
    configureLooxMobileLimit();
    resetLooxMobileReviews();

    if (!mobileQuery.matches) return;

    const scopes = uniqueElements(Array.from(document.querySelectorAll(scopeSelector)));

    scopes.forEach((scope) => {
      const cards = uniqueElements(Array.from(scope.querySelectorAll(cardSelector)))
        .filter((card) => (card.textContent || '').trim().length > 40);

      groupCardsByParent(cards).forEach((group, parent) => {
        if (group.length < 2) return;

        parent.classList.add('piur-loox-mobile-track');

        group.forEach((card, index) => {
          card.classList.add('piur-loox-mobile-card');
          card.dataset.piurLooxExtra = index >= 4 ? 'true' : 'false';

          const text = findReviewText(card);
          if (text) text.classList.add('piur-loox-mobile-text');
        });
      });
    });
  }

  let scheduled = false;

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      applyLooxMobileReviews();
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleApply);
  configureLooxMobileLimit();
  window.addEventListener('load', scheduleApply);
  mobileQuery.addEventListener('change', scheduleApply);

  const observer = new MutationObserver(scheduleApply);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.setTimeout(scheduleApply, 1000);
  window.setTimeout(scheduleApply, 3000);
  window.setTimeout(scheduleApply, 6000);
})();
